import { WhiteLabelAverageSession } from './wl-average-sessions-model';
import { Expose, Type } from 'class-transformer';
import { Model } from './model';
import { WhiteLabelTotalSessions } from './wl-total-sessions';

export class WhiteLabelTotalWithAverageSessions extends Model {
  @Expose()
  @Type(() => WhiteLabelTotalSessions)
  totals: WhiteLabelTotalSessions;
  @Expose()
  @Type(() => WhiteLabelAverageSession)
  averages: WhiteLabelAverageSession;
}
